import { render, staticRenderFns } from "./SearchWildcard.vue?vue&type=template&id=faf2a6c6&scoped=true"
import script from "./SearchWildcard.vue?vue&type=script&lang=js"
export * from "./SearchWildcard.vue?vue&type=script&lang=js"
import style0 from "./SearchWildcard.vue?vue&type=style&index=0&id=faf2a6c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf2a6c6",
  null
  
)

export default component.exports